import { render, staticRenderFns } from "./AddCompanyEmisorasForm.vue?vue&type=template&id=e5c72e0c"
import script from "./AddCompanyEmisorasForm.vue?vue&type=script&lang=js"
export * from "./AddCompanyEmisorasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports